<script setup lang="ts">
import { Color, ColorSemantic } from '@previo/codebooks'
import { useTypographyClasses } from '../composables/useTypographyClasses'
import { PWhiteSpace, type PMaxLines } from '../types'

type Props = {
  text?: null | string | number
  color?: null | Color | ColorSemantic
  bold?: boolean
  italic?: boolean
  underline?: boolean
  strike?: boolean
  maxLines?: null | PMaxLines
  ellipsis?: boolean
  whiteSpace?: PWhiteSpace
}

const props = withDefaults(defineProps<Props>(), {
  bold: false,
  italic: false,
  underline: false,
  strike: false,
  ellipsis: false,
  whiteSpace: PWhiteSpace.PRE_LINE,
})

const cssClasses = useTypographyClasses(props)
</script>

<template>
  <div :class="cssClasses">
    {{ text }}
  </div>
</template>

<style scoped lang="scss">
@import '../../../assets/scss/shared/mixins';
@import '../../../assets/scss/shared/components/typography';

div {
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
}
</style>
